import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import './styles.css';

/* ── Asset Imports for Social Services Collage ── */
import imgFoodDrive    from '../../assets/hero/hero-kids-drawing.jpg';
import imgMedical      from '../../assets/hero/hero-doctor-checkup.jpg';
import imgEducation    from '../../assets/hero/hero-kids-backpacks.jpg';

/* ── Core Arms: Logos (constant) + Real Photos (clickable) ── */
import logoICM   from '../../assets/hero/icm-logo.png';
import logoVMC   from '../../assets/hero/vmc-logo.png';
import photoICM  from '../../assets/hero/icm-graduation.jpg';
import photoVMC  from '../../assets/hero/vmc-team.jpg';

/* ── VMC Editorial Section 1 Custom Images ── */
import vmcBpCheck          from '../../assets/hero/vmc-bp-check.jpg';
import vmcVolunteerSession from '../../assets/hero/vmc-volunteer-session.jpg';
import vmcGirlsClassroom   from '../../assets/hero/vmc-girls-classroom.jpg';
import vmcClassroomTalk    from '../../assets/hero/vmc-classroom-talk.jpg';

/* ── ICM Editorial Section 1 Custom Images ── */
import icmPrayingChildren  from '../../assets/hero/icm-praying-children.jpg';
import icmSmilingGroup     from '../../assets/hero/icm-smiling-group.jpg';

const CORE_ARMS_DATA = [
  {
    id: 'icm',
    title: 'InnerCity Mission for Children (ICM)',
    tag: 'Innercity Mission',
    icon: '🎓',
    logo: logoICM,
    photo: photoICM,
    img: imgEducation,
    shortDesc: 'The InnerCity Mission for Children focuses on nurturing, educating, and empowering the next generation. We are creating a place where children with special needs can thrive',
    definition: 'The InnerCity Mission for Children is a faith-based humanitarian organization dedicated to breaking the cycle of child poverty. ICM ensures indigent children stay in school, receive daily nutritious meals, gain access to healthcare, and grow up in empowered families.',
    pillars: [
      { icon: '📚', name: 'Education for All', desc: 'Sponsoring back-to-school kits, textbooks, and tuition.' },
      { icon: '🍲', name: 'Feed Hungry Children', desc: 'Distributing thousands of food parcels & daily hot meals.' },
      { icon: '👩‍👧', name: 'Family Empowerment', desc: 'Micro-grants and vocational skills training for mothers.' },
      { icon: '🩺', name: 'Child Healthcare', desc: 'Providing deworming, routine checkups & emergency aid.' }
    ],
    impactStat: null,
    stats: [
      { val: '500K+', label: 'Children Reached' },
      { val: '150+', label: 'Schools Supported' },
      { val: '2M+', label: 'Meals Distributed' }
    ],
    ctaText: 'Partner with InnerCity Mission',
    ctaLink: 'https://kingschat.online'
  },
  {
    id: 'vmc',
    title: 'Voluntary Medical Corps (VMC)',
    tag: 'Volunteer Medical Corps',
    icon: '🩺',
    logo: logoVMC,
    photo: photoVMC,
    img: imgMedical,
    shortDesc: 'We are an ever-expanding global network of Christian health care workers, non-medical volunteers and students committed to providing medical care through outreaches, humanitarian assistance and sustainable health care solutions in regions of crisis and to communities in dire need.',
    definition: 'Established as a network of Christian health workers, paramedics and students in every nation; we admit everyone whose primary intent is to enhance health, and who is committed to the mission of providing humanitarian assistance to communities and persons in need.',
    pillars: [
      { icon: '🚨', name: 'Disaster Response', desc: 'Rapid medical first-responders deployed in crisis zones.' },
      { icon: '🏥', name: 'Free Surgical Camps', desc: 'Rural health outreaches, eye checkups & minor surgeries.' },
      { icon: '🩺', name: 'Community Health', desc: 'Hygiene awareness, CPR workshops & maternal care.' },
      { icon: '🩸', name: 'Blood Donation', desc: 'Partnering with regional blood banks to save lives.' }
    ],
    impactStat: '100,000+ Patients Treated Free',
    stats: [
      { val: '100K+', label: 'Patients Treated' },
      { val: '45+', label: 'Medical Missions' },
      { val: '12K+', label: 'Volunteers Active' }
    ],
    ctaText: 'Join Voluntary Medical Corps',
    ctaLink: 'https://kingschat.online'
  }
];

const SocialServices = () => {
  const [activeArchive, setActiveArchive] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScrollToOutreaches = () => {
    const el = document.getElementById('core-arms-section');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="social-services-page">
      <Navbar />

      {/* ── Background Blobs & Stage Lights ── */}
      <div className="ss-blob ss-blob-1" />
      <div className="ss-blob ss-blob-2" />
      <div className="ss-blob ss-blob-3" />

      {/* ── Pinterest-Style Asymmetric Split Hero ── */}
      <section className="ss-hero">
        <div className="ss-container">
          <div className="ss-hero-split">

            {/* Left Column: Typography, Badges & Actions */}
            <div className="ss-hero-left">
              <div className="ss-hero-badge">
                <span className="ss-badge-dot" /> HUMANITARIAN & SOCIAL OUTREACHES
              </div>

              <h1 className="ss-hero-title">
                Restoring Hope, <br />
                <span>Transforming Lives</span> <br />
                Across Communities.
              </h1>

              <p className="ss-hero-subtitle">
                Extending the hands of Christ's love to nourish families, provide free healthcare, 
                empower underprivileged students, and rebuild lives across Pune and beyond.
              </p>

              <div className="ss-hero-actions">
                <button className="btn-ss-primary" onClick={handleScrollToOutreaches}>
                  Explore Outreaches <span>↓</span>
                </button>
                <button 
                  onClick={(e) => e.currentTarget.innerText = "Partner by - Contact Us: +918040184671 / +919529607156"} 
                  className="btn-ss-secondary"
                >
                  Partner With Us
                </button>
              </div>
            </div>

            {/* Right Column: Pinterest Layered Photo Collage Cluster */}
            <div className="ss-hero-right">
              <div className="ss-collage-cluster">

                {/* Main Large Center Card */}
                <div className="ss-cluster-card main-card">
                  <img src={imgFoodDrive} alt="Food Drive Outreach" />
                  <div className="ss-card-gradient-overlay" />
                  <div className="ss-cluster-caption">
                    <span className="ss-caption-tag">HUNGER RELIEF</span>
                    <h3>Weekly Food Distribution Drives</h3>
                  </div>
                </div>

                {/* Top-Right Overlapping Card */}
                <div className="ss-cluster-card top-right-card">
                  <img src={imgMedical} alt="Free Medical Camp" />
                  <div className="ss-card-badge-mini">🩺 Free Healthcare</div>
                </div>

                {/* Bottom-Left Overlapping Card */}
                <div className="ss-cluster-card bottom-left-card">
                  <img src={imgEducation} alt="Child Education Support" />
                  <div className="ss-card-badge-mini">📚 Youth Education</div>
                </div>

                {/* Floating Metric Sticker 1 */}
                <div className="ss-floating-badge badge-top">
                  <div>
                    <strong>Children's Education</strong>
                    <small>Support</small>
                  </div>
                </div>

                {/* Floating Metric Sticker 2 */}
                <div className="ss-floating-badge badge-bottom">
                  <div>
                    <strong>Health & Wellness</strong>
                    <small>Campaign</small>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── SECTION 2: ARCHIVE-STYLE INTERACTIVE COLLAGE ── */}
      <section className="ss-core-arms-section archive-style" id="core-arms-section">
        <div className="ss-container">

          {/* Header Row */}
          <div className="archive-top-row">
            <div className="archive-header-left">
              <h2 className="archive-title">Core Social Service Platforms</h2>
              <div className="archive-desc-cols">
                <p>These platforms present our compiled global humanitarian arms, organized according to their mission and mandate. Each one is cataloged by its core pillars, reach, and purpose.</p>
                <p>The featured programs represent initiatives spanning local and international outreach, grouped by impact category. Hover or tap a card to reveal its full mandate and pillars.</p>
              </div>
            </div>

            <div className="archive-header-right">
              <div className="archive-meta">
                <span className="archive-meta-label">Humanitarian Arms</span>
                <span className="archive-meta-date">Active Since Inception</span>
              </div>
            </div>
          </div>

          {/* Collage */}
          <div className={`archive-collage ${activeArchive ? 'has-active' : ''}`}>

            {/* Constant Logo Cards (always visible, non-interactive) */}
            {CORE_ARMS_DATA.map((arm) => (
              <div key={`logo-${arm.id}`} className={`archive-logo-card logo-${arm.id}`}>
                <img src={arm.logo} alt={`${arm.title} logo`} />
              </div>
            ))}

            {/* Clickable Photo Cards — click to reveal description */}
            {CORE_ARMS_DATA.map((arm) => (
              <div
                key={arm.id}
                className={`archive-photo-card card-${arm.id} ${activeArchive === arm.id ? 'is-active' : ''} ${activeArchive && activeArchive !== arm.id ? 'is-dimmed' : ''}`}
                onClick={() => {
                  if (activeArchive !== arm.id) {
                    setActiveArchive(arm.id);
                  }
                }}
              >
                <img src={arm.photo} alt={arm.title} />
                <span className="archive-photo-tag">{arm.icon} {arm.tag}</span>
              </div>
            ))}

            {/* Detail Panel — shown only after a click */}
            {activeArchive && (() => {
              const arm = CORE_ARMS_DATA.find(a => a.id === activeArchive);
              return (
                <div className="archive-detail-card">
                  <span className="archive-detail-label">{arm.icon} {arm.title}</span>
                  <p className="archive-detail-desc">{arm.shortDesc}</p>
                  {arm.impactStat && <span className="archive-detail-stat">✨ {arm.impactStat}</span>}
                  <div className="archive-detail-actions">
                    <button
                      onClick={(e) => e.currentTarget.innerText = "Partner by - Contact Us: +918040184671 / +919529607156"}
                      className="archive-download-btn"
                    >
                      ⬇ Partner
                    </button>
                    <button
                      className="archive-close-btn"
                      onClick={() => setActiveArchive(null)}
                      aria-label="Close"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              );
            })()}

          </div>
        </div>
      </section>

      {/* ── ADDITIONAL EDITORIAL SECTIONS ── */}
      {/* VMC Editorial Sections */}
      <div className="vmc-editorial-container">
        {/* VMC Section 1: Asymmetrical 4-Column Layout */}
        <section className="vmc-editorial-sec">
          <div className="vmc-editorial-inner">
            
            {/* Col 1 */}
            <div className="vmc-col vmc-col-1">
              <h2 className="vmc-editorial-title">
                PROVIDING <br />
                MEDICAL <br />
                CARE
              </h2>
              <div className="vmc-img-card vmc-card-sm">
                <img src={vmcBpCheck} alt="Clinical checkup / BP camp" />
                <div className="vmc-caption">
                  <h4>Community Outreaches</h4>
                  <p>Providing medical care through outreaches, hygiene camps, and diagnostic clinics directly to communities in dire need.</p>
                </div>
              </div>
            </div>

            {/* Col 2 */}
            <div className="vmc-col vmc-col-2">
              <div className="vmc-img-card vmc-card-tall">
                <img src={vmcVolunteerSession} alt="VMC volunteer session with families" />
                <div className="vmc-caption">
                  <h4>Humanitarian Assistance</h4>
                  <p>Providing essential medical aid, disaster response, and clinical support to vulnerable families in regions of crisis.</p>
                </div>
              </div>
            </div>

            {/* Col 3 */}
            <div className="vmc-col vmc-col-3">
              <div className="vmc-img-card vmc-card-landscape">
                <img src={vmcGirlsClassroom} alt="Clinical safety and education camp" />
              </div>
              <div className="vmc-text-block">
                <h4>Sustainable Health Solutions</h4>
                <p>Empowering communities with healthcare training, health education, first-aid seminars, and sustainable wellness tools.</p>
              </div>
            </div>

            {/* Col 4 */}
            <div className="vmc-col vmc-col-4">
              <div className="vmc-img-card vmc-card-tall">
                <img src={vmcClassroomTalk} alt="Doctor talk at school classroom" />
                <div className="vmc-caption">
                  <h4>Expanding Global Network</h4>
                  <p>A network of Christian healthcare workers, paramedics, students, and volunteers committed to enhancing global health.</p>
                </div>
              </div>
              <button 
                onClick={(e) => e.currentTarget.innerText = "Partner by - Contact Us: +918040184671 / +919529607156"} 
                className="vmc-btn-dark"
              >
                Partner with us
              </button>
            </div>

          </div>
        </section>

        {/* VMC Section 2: Dark Green Split Layout */}
        <section className="vmc-feature-sec">
          <div className="vmc-feature-inner">
            <div className="vmc-feature-left">
              <h2 className="vmc-feature-title">
                PROVIDING MEDICAL CARE <br />
                WHERE IT'S NEEDED MOST
              </h2>
              <p className="vmc-feature-text">
                Established as a network of Christian health workers, paramedics and students in every nation; we admit everyone whose primary intent is to enhance health, and who is committed to the mission of providing humanitarian assistance to communities and persons in need.
              </p>
            </div>

            <div className="vmc-feature-right">
              <div className="vmc-carousel-wrapper">
                <img src={photoVMC} alt="VMC Doctor conducting camp session" className="vmc-carousel-img" />
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ICM Editorial Sections */}
      <div className="vmc-editorial-container">
        {/* ICM Section 1: Asymmetrical 4-Column Layout */}
        <section className="vmc-editorial-sec">
          <div className="vmc-editorial-inner">
            
            {/* Col 1 */}
            <div className="vmc-col vmc-col-1">
              <h2 className="vmc-editorial-title">
                EDUCATION <br />
                FOR EVERY <br />
                CHILD
              </h2>
              <div className="vmc-img-card vmc-card-sm">
                <img src={icmPrayingChildren} alt="Primary Education support praying children" />
                <div className="vmc-caption">
                  <h4>A Fundamental Right</h4>
                  <p>Education is a fundamental right, yet poverty and violence limit millions of children from getting an education.</p>
                </div>
              </div>
            </div>

            {/* Col 2 */}
            <div className="vmc-col vmc-col-2">
              <div className="vmc-img-card vmc-card-tall">
                <img src={photoICM} alt="InnerCity Mission Classroom Activity" />
                <div className="vmc-caption">
                  <h4>Holistic Education Program</h4>
                  <p>With a focus on free Primary and Early Childhood Education, our program is holistic and believes in nurturing indigent children.</p>
                </div>
              </div>
            </div>

            {/* Col 3 */}
            <div className="vmc-col vmc-col-3">
              <div className="vmc-img-card vmc-card-landscape">
                <img src={imgFoodDrive} alt="Mothers cooking and packaging food" />
              </div>
              <div className="vmc-text-block">
                <h4>The 5 Core Pillars</h4>
                <p>Our program includes Primary Schools, Back to School Campaign, Education in Emergencies, Teachers Training, and Girl Child Education.</p>
              </div>
            </div>

            {/* Col 4 */}
            <div className="vmc-col vmc-col-4">
              <div className="vmc-img-card vmc-card-tall">
                <img src={icmSmilingGroup} alt="Children smiling group" />
                <div className="vmc-caption">
                  <h4>InnerCity Mission Schools</h4>
                  <p>Directly offering tuition-free early childhood education and uninterrupted access to 6-year primary education.</p>
                </div>
              </div>
              <button 
                onClick={(e) => e.currentTarget.innerText = "Partner by - Contact Us: +918040184671 / +919529607156"} 
                className="vmc-btn-dark"
              >
                Partner with InnerCity Mission
              </button>
            </div>

          </div>
        </section>

        {/* ICM Section 2: Dark Green Split Layout */}
        <section className="vmc-feature-sec">
          <div className="vmc-feature-inner">
            <div className="vmc-feature-left">
              <h2 className="vmc-feature-title">
                NURTURING, EDUCATING <br />
                AND EMPOWERING
              </h2>
              <p className="vmc-feature-text">
                The InnerCity Mission Education Program is holistic. We believe that quality learning for developing indigent children requires adequate learning tools, safe environment, and qualified teachers to help them thrive.
              </p>
            </div>

            <div className="vmc-feature-right">
              <div className="vmc-carousel-wrapper">
                <img src={photoICM} alt="ICM Classroom paper boat activity" className="vmc-carousel-img" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SocialServices;